<template> 
    <div class="notice">  
        <div class="leading-normal">
            <slot></slot>
        </div> 
    </div> 
</template>

<script>
import {  defineComponent } from 'vue';

export default defineComponent({ 
    setup: function () { 
    }
})
</script>

<style lang="scss" scoped>   
.notice {
    @apply pt-3 pb-4 pl-7 pr-7 text-10 font-light text-a-black-484848 text-left;
    padding-right: 26px; 
    padding-left: 26px;
}
</style>